import React from 'react';
import { Redirect } from 'wouter';
import { useSingleSignOnQuery } from './SingleSignOnHooks';

export const ManageSingleSignOnSwitch = () => {

    const { isLoading, data } = useSingleSignOnQuery();

    if (isLoading) {
        return null;
    }

    if (!data.configured) {
        return <Redirect to="~/manage/sso/setup" />;
    }

    if (!data.legacy) {
        return <Redirect to="~/manage/sso/v2" />;
    }

    return <Redirect to="~/manage/sso/v1" />;
};
